// extracted by mini-css-extract-plugin
export var actionButton = "_f2-t";
export var buttonContainer = "_f2-0";
export var buttonContainer2 = "_f2-1";
export var buttonSection = "_f2-2";
export var details = "_f2-3";
export var dropdownItem = "_f2-5";
export var dropdownItemsContainer = "_f2-4";
export var fileInput = "_f2-r";
export var headerButton = "_f2-6";
export var icon = "_f2-7";
export var input = "_f2-8";
export var macroListItem = "_f2-9";
export var mainContent = "_f2-a";
export var microText = "_f2-b";
export var modal = "_f2-w";
export var optionsButton = "_f2-c";
export var paperclip = "_f2-s";
export var pillContent = "_f2-d";
export var preview = "_f2-e";
export var preview2 = "_f2-f";
export var quillEditor = "_f2-q";
export var selectedMacro = "_f2-g";
export var sidebar = "_f2-h";
export var sidebarHeader = "_f2-j";
export var sidebarList = "_f2-i";
export var sidebarListItem = "_f2-k";
export var sidebarSearch = "_f2-l";
export var snoozeDurationWrapper = "_f2-v";
export var statusPillContainer = "_f2-m";
export var tagsContainer = "_f2-n";
export var unselectedMacro = "_f2-o";
export var variable = "_f2-u";
export var wrapper = "_f2-p";